import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgPolygonComponent } from './svgpolygon.component';
import { SvgHelper } from '../../helpers/svghelper.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgPolygonComponent],
  exports: [SvgPolygonComponent],
  providers: [SvgHelper]
})
export class SvgPolygonModule { }
